import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';

export const ROLE_STANDIST_AGENCY = 'ROLE_STANDIST_AGENCY';
export const ROLE_STANDIST_DECORATOR = 'ROLE_STANDIST_DECORATOR';
export const ROLE_STANDIST_EXHIBITOR = 'ROLE_STANDIST_EXHIBITOR';

export type StandistRole = 'ROLE_STANDIST_AGENCY' | 'ROLE_STANDIST_DECORATOR' | 'ROLE_STANDIST_EXHIBITOR';

const standistRoles = [ROLE_STANDIST_AGENCY, ROLE_STANDIST_DECORATOR, ROLE_STANDIST_EXHIBITOR];

export const getStandistRoleIntlLabel = (roleReference: string) => {
  switch (roleReference) {
    case ROLE_STANDIST_AGENCY:
      return <FormattedMessageWrapper id="Agence" />;
    case ROLE_STANDIST_DECORATOR:
      return <FormattedMessageWrapper id="Décorateur" />;
    case ROLE_STANDIST_EXHIBITOR:
      return <FormattedMessageWrapper id="Exposant" />;
    default:
      return roleReference;
  }
};

export default standistRoles;
